import React from 'react';
import { findBankLogo } from '../../utils/utils';
import {
    getShebaInfo,
    getBankNameFromCardNumber,
} from '@persian-tools/persian-tools';
import { Box } from '@mui/material';

export type BankLogoProps = {
    bankName?: string;
    iban?: string;
    cardNumber?: string;
    width?: any;
    height?: any;
};

export function BankLogo({
    bankName,
    iban,
    cardNumber,
    width,
    height,
}: BankLogoProps): JSX.Element {
    let logo = '';
    let logoColor = '';

    if (iban) {
        const sheba = getShebaInfo(iban);

        if (sheba) bankName = sheba?.persianName + '';
    }

    if (cardNumber) {
        bankName = getBankNameFromCardNumber(cardNumber) + '';
    }

    if (bankName) logo = findBankLogo(bankName);

    return (
        <Box
            sx={{
                width: width ?? 'auto',
                height: height ?? '30px',
                minWidth: '30px',
                display: 'flex',
                alignItems: 'center',
            }}>
            {logo ? (
                <img
                    style={{
                        width: '100%',
                        height: '100%',
                        transform: 'translateY(-2px)',
                    }}
                    src={logo}
                    alt=""
                />
            ) : (
                <img
                    style={{
                        width: '100%',
                        height: '100%',
                        transform: 'translateY(-2px)',
                    }}
                    src={'/images/shetabb.svg'}
                    alt=""
                />
                // <i
                //     className="fa-light fa-building-columns"
                //     style={{ fontSize: '23px', transform: 'translateY(-1px)' }}
                // />
            )}
        </Box>
    );
}
